import { Observable } from 'rxjs';
import { InjectionToken } from '../../injection';

/**
 * Function that returns the device token for push notifications.
 */
export type DeviceTokenFactory = () => Observable<string | undefined>;

export const DEVICE_TOKEN_FACTORY: InjectionToken<DeviceTokenFactory>
  = new InjectionToken<DeviceTokenFactory>('DEVICE_TOKEN_FACTORY');
